import {
  GAS_FAILURE,
  GAS_PENDING,
  GAS_SUCCESS,
  GNAS_SUCCESS,
  GNAS_FAILURE,
  GNAS_PENDING,
  GACS_SUCCESS,
  GACS_FAILURE,
  GACS_PENDING,
  DA_SUCCESS,
} from './constants'
import {getAudits as getAuditsAPI} from '../../../services/audits'
import {getAuditItemsCount as getAuditItemsCountAPI} from '../../../services/audits'

export async function getAudits(params = {}, dispatch) {
  dispatch({type: GAS_PENDING})
  try {
    let response = await getAuditsAPI(params)
    dispatch({type: GAS_SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Audits Failed`)
    dispatch({type: GAS_FAILURE, payload: e})
  }
}

export async function getNextPageAudits(params = {}, dispatch) {
  dispatch({type: GNAS_PENDING, payload: []})
  try {
    let response = await getAuditsAPI(params)
    dispatch({type: GNAS_SUCCESS, payload: response})
    dispatch({type: DA_SUCCESS, payload: 'loading'})
    return response
  } catch (e) {
    console.log(`Get Audits Failed`)
    dispatch({type: DA_SUCCESS, payload: 'loading'})
    dispatch({type: GNAS_FAILURE, payload: e})
    return e.response
  }
}

export async function getAuditItemsCount(params = {}, dispatch) {
  dispatch({type: GACS_PENDING, payload: []})
  try {
    let response = await getAuditItemsCountAPI(params)
    dispatch({type: GACS_SUCCESS, payload: response})
    // dispatch({type: DA_SUCCESS, payload: 'loading'})
    return response
  } catch (e) {
    console.log(`Get Audits Failed`)
    // dispatch({type: DA_SUCCESS, payload: 'loading'})
    dispatch({type: GACS_FAILURE, payload: e})
    return e.response
  }
}
